import React from 'react';

interface MultiSelectProps {
  label: string;
  options: string[];
  selectedOptions: string[];
  onChange: (selected: string[]) => void;
  error?: string;
  columns?: number;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  label,
  options,
  selectedOptions,
  onChange,
  error,
  columns = 1,
}) => {
  const handleOptionChange = (option: string) => {
    const updatedSelection = selectedOptions.includes(option)
      ? selectedOptions.filter((item) => item !== option)
      : [...selectedOptions, option];
    onChange(updatedSelection);
  };

  const columnStyle = `grid grid-cols-${columns} gap-4`;

  return (
    <div className="w-full mb-4">
      <label className="block font-bold text-[16px] mb-1">
        {label}
        <span className="text-red-500">*</span>
      </label>
      <div className="p-2">
        <ul className={`space-y-0 ${columnStyle}`}>
          {options.map((option) => (
            <li key={option} className="flex items-center">
              <input
                type="checkbox"
                checked={selectedOptions.includes(option)}
                onChange={() => handleOptionChange(option)}
                className="form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
              />
              <label className="ml-2 text-[16px] font-bold">{option}</label>
            </li>
          ))}
        </ul>
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    </div>
  );
};

export default MultiSelect;
